var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22.348,
    viewBox: "0 0 25 22.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7778",
    "data-name": "Path 7778",
    d: "M561.1,259.867l-.092,0-3.031-5.249a2.316,2.316,0,1,0-4.022-2.28h-5.871a2.316,2.316,0,1,0-4.066,2.21l-3.076,5.327c-.069-.006-.139-.01-.21-.01a2.316,2.316,0,1,0,0,4.632c.071,0,.141,0,.21-.01l3.1,5.361a2.316,2.316,0,1,0,4.078,2.176h5.716a2.316,2.316,0,1,0,4.082-2.169l3.095-5.36.092,0a2.316,2.316,0,0,0,0-4.632Zm-5.158,8.891a2.317,2.317,0,0,0-2.135,1.416h-5.669a2.316,2.316,0,0,0-2.569-1.375l-3-5.2a2.314,2.314,0,0,0,0-2.827l2.969-5.142a2.319,2.319,0,0,0,2.63-1.435h5.709a2.314,2.314,0,0,0,2.553,1.449l2.91,5.041a2.314,2.314,0,0,0,0,3l-2.954,5.116A2.324,2.324,0,0,0,555.947,268.758Z",
    transform: "translate(-538.422 -251.042)",
    fill: "#ffbe00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.8f89b610297ea6add93b82adcd65835d.svg";
export { ForwardRef as ReactComponent };